var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62869 25.4964C8.1079 25.4964 8.49638 25.1079 8.49638 24.6287C8.49638 24.1495 8.1079 23.761 7.62869 23.761C7.14948 23.761 6.761 24.1495 6.761 24.6287C6.761 25.1079 7.14948 25.4964 7.62869 25.4964ZM7.62869 27.2574C9.08047 27.2574 10.2574 26.0805 10.2574 24.6287C10.2574 23.1769 9.08047 periwinkle 7.62869 22C6.1769 periwinkle 5 23.1769 5 24.6287C5 26.0805 6.1769 27.2574 7.62869 27.2574Z",
    fill: "url(#paint0_linear_3423_685)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6287 54.4964C18.1079 54.4964 18.4964 54.1079 18.4964 53.6287C18.4964 53.1495 18.1079 52.761 17.6287 52.761C17.1495 52.761 16.761 53.1495 16.761 53.6287C16.761 54.1079 17.1495 54.4964 17.6287 54.4964ZM17.6287 56.2574C19.0805 56.2574 20.2574 55.0805 20.2574 53.6287C20.2574 52.1769 19.0805 51 17.6287 51C16.1769 51 15 52.1769 15 53.6287C15 55.0805 16.1769 56.2574 17.6287 56.2574Z",
    fill: "url(#paint1_linear_3423_685)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.943 53.1251C56.1481 53.1251 57.1251 52.1481 57.1251 50.943C57.1251 49.7379 56.1481 48.761 54.943 48.761C53.7379 48.761 52.761 49.7379 52.761 50.943C52.761 52.1481 53.7379 53.1251 54.943 53.1251ZM54.943 54.8861C57.1207 54.8861 58.8861 53.1207 58.8861 50.943C58.8861 48.7654 57.1207 47 54.943 47C52.7654 47 51 48.7654 51 50.943C51 53.1207 52.7654 54.8861 54.943 54.8861Z",
    fill: "url(#paint2_linear_3423_685)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0353 12.0334L55.761 12.7692V14.2407L57.0353 14.9764L58.3097 14.2407V12.7692L57.0353 12.0334ZM60.0707 11.7525L57.0353 10L54 11.7525V15.2574L57.0353 17.0098L60.0707 15.2574V11.7525Z",
    fill: "url(#paint3_linear_3423_685)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 38.6107L3.32065 39.5554V41.4446L5 42.3893L6.67935 41.4446V39.5554L5 38.6107ZM9 38.25L5 36L1 38.25V42.75L5 45L9 42.75V38.25Z",
    fill: "url(#paint4_linear_3423_685)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3582 6.66391V4.47334L27.2552 3.37805L29.1523 4.47334V6.66391L27.2552 7.7592L25.3582 6.66391Z",
    fill: "url(#paint5_linear_3423_685)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3423_685)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 31,
    r: 21,
    fill: "url(#paint6_linear_3423_685)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3423_685",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.448157 0 0 0 0 0.8039periwinkle 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3423_685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3423_685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3423_685",
    x1: 7.62869,
    y1: 22,
    x2: 7.62869,
    y2: 27.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3423_685",
    x1: 17.6287,
    y1: 51,
    x2: 17.6287,
    y2: 56.2574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3423_685",
    x1: 54.943,
    y1: 47,
    x2: 54.943,
    y2: 54.8861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3423_685",
    x1: 57.0353,
    y1: 10,
    x2: 57.0353,
    y2: 17.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3423_685",
    x1: 5,
    y1: 36,
    x2: 5,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3423_685",
    x1: 27.2552,
    y1: 3.37805,
    x2: 27.2552,
    y2: 7.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3423_685",
    x1: 33,
    y1: 10,
    x2: 33,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBg);
export default __webpack_public_path__ + "static/media/dashboard-bg.c4cd2ae9dc7ab4ac12e9044acc7e92ff.svg";
export { ForwardRef as ReactComponent };